"use strict";
// NOTE: `file_comment_added` and `file_comment_edited` are left out because they are discontinued
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=file.js.map